// import React, { useState, useEffect, useCallback } from "react";
// import {
//   Typography,
//   Divider,
//   Button,
//   TextField,
//   Grid,
//   FormGroup,
//   FormControlLabel,
//   InputAdornment,
// } from "@mui/material";
// import useStyles from "./style";
// import CustomSwitch from "SharedComponents/CustomSwitch";
// import { useFormik } from "formik";
// import * as yup from "yup";
// import settingsApi from "Services/Settings";
// import ImageUploadApi from "Services/ImageUpload";
// import { showLoader, hideLoader } from "Redux/Loader/actions";
// import { showSnackbar } from "Redux/SnackBar/actions";
// import { setNewSiteLogo } from "Redux/SiteSettings/actions";
// import { useDispatch, useSelector } from "react-redux";
// import _ from "lodash";

// import VisibilityIcon from "@mui/icons-material/Visibility";
// import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

// import Box from "@mui/material/Box";
// import MenuItem from "@mui/material/MenuItem";

// //
// import { CUSTOM_CONSTANTS } from "../../../Constants";

// import DropZone from "./DropZone";

// const SiteSettings = () => {
//   const classes = useStyles();
//   const dispatch = useDispatch();
//   const demoaccount_id = useSelector(
//     (state) => state?.AuthReducer?.demoaccount_id || ""
//   );
//   const userid = useSelector(
//     (state) => state?.AuthReducer?.userId || ""
//   );
//   const [appState, setAppState] = useState(true);
//   const [smsState, setSmsState] = useState(true);
//   const [values, setValues] = useState(null);
//   const [siteLogo, setSiteLogo] = useState("");

//  // const [showIosDriverMapKey, setShowIosDriverMapKey] = useState(false);

//   // Save or Edit profile details
//   const handleSettings = (formValues) => {
//     dispatch(showLoader("Loading please wait..."));
//     const data = {
//       siteName: formValues?.siteName,
//       copyRightContent: formValues?.copyRightContent,
//       playStoreLink: formValues?.playStoreLink,
//       appStoreLink: formValues?.appStoreLink,
//       sosNumber: formValues?.sosNumber,
//       contactNumber: formValues?.contactNumber,
//       contactEmail: formValues?.contactEmail,
//       driverAppversion: formValues?.driverAppversion,
//       userAppversion : formValues?.userAppversion,
//       demoaccount_id: demoaccount_id,
//       userid: userid,
//     };

//     const onSuccess = (res) => {
//       dispatch(hideLoader());
//       if (res?.data?.status === true) {
//         dispatch(
//           showSnackbar({
//             message: res?.data?.message || "Updated site settings successfully",
//             autoHideDuration: 3000,
//             anchorOrigin: {
//               vertical: "top",
//               horizontal: "right",
//             },
//             variant: "success",
//           })
//         );
//         formik?.resetForm();
//         setValues(null);
//         getMasterValues();
//       }
//     };
//     const onFailure = (err) => {
//       dispatch(hideLoader());
//       dispatch(
//         showSnackbar({
//           message: err?.response?.data?.message || "Error while update site settings",
//           autoHideDuration: 3000,
//           anchorOrigin: {
//             vertical: "top",
//             horizontal: "right",
//           },
//           variant: "error",
//         })
//       );
//       //console.log("settings value update api", err);
//     };
//     settingsApi.updateMasterValues({ ...data }).then(onSuccess, onFailure);
//   };

//   const formik = useFormik({
//     initialValues: {
//       siteName: "",
//       copyRightContent: "",
//       playStoreLink: "",
//       appStoreLink: "",
//       sosNumber: "",
//       contactNumber: "",
//       contactEmail: "",
//       driverAppversion: '',
//       userAppversion: '',
//     },
//     enableReinitialize: true,
//     validationSchema: yup.object({
//       siteName: yup.string().required("Site Name is required").nullable(),
//     driverAppversion: yup
//     .string()
//     .required("Driver app version is required")
//     .matches(/^\d+(\.\d+)?$/, "Only numeric versions like 3.0 or 3.6 are allowed")
//     .nullable(),
//     userAppversion: yup
//     .string()
//     .required("User app version is required")
//     .matches(/^\d+(\.\d+)?$/, "Only numeric versions like 3.0 or 3.6 are allowed")
//     .nullable(),      
//       contactNumber: yup
//         .string()
//         .required("Contact Number is required")
//         .matches(/^[0-9]+$/, "Only Numbers are allowed")
//         .max(10, `Max 10 digits are allowed`)
//         .min(10, `Must be exactly 10 numbers`)
//         .nullable(),
//       contactEmail: yup
//         .string()
//         .email("Enter a valid Email Address")
//         .nullable(),
//       sosNumber: yup.string().matches(/^[0-9]+$/, "Only Numbers are allowed"),
//     }),
//     onSubmit: handleSettings,
//   });

//   // Get Master Values
//   const getMasterValues = useCallback(() => {
//     dispatch(showLoader("Loading please wait..."));
//     const params = {};
    
//      if (userid) {
//       params.userid = userid;
//     }
//     const onSuccess = (res) => {
//       dispatch(hideLoader());
//       if (res?.data?.status === true) {
//         setValues(res?.data?.data);
//       } else {
//         setValues([]);
//       }
//     };
//     const onFailure = (err) => {
//       dispatch(hideLoader());
//       dispatch(
//         showSnackbar({
//           message: err?.response?.data?.message || "Failed to fetch data",
//           autoHideDuration: 3000,
//           anchorOrigin: {
//             vertical: "top",
//             horizontal: "right",
//           },
//           variant: "error",
//         })
//       );
//     };
//     settingsApi.getMasterValues(params).then(onSuccess, onFailure);
//   }, [userid]);

//   useEffect(() => {
//     getMasterValues();
//   }, [getMasterValues]);

//   // Set fetched values for master
//   useEffect(() => {
//     if (!_.isEmpty(values)) {
//       formik.setFieldValue("siteName", values?.siteName);
//       formik.setFieldValue("copyRightContent", values?.copyRightContent);
//       formik.setFieldValue("siteName", values?.siteName);
//       formik.setFieldValue("copyRightContent", values?.copyRightContent);
//       formik.setFieldValue("playStoreLink", values?.playStoreLink);
//       formik.setFieldValue("appStoreLink", values?.appStoreLink);
//       formik.setFieldValue("sosNumber", values?.sosNumber);
//       formik.setFieldValue("contactNumber", values?.contactNumber);
//       formik.setFieldValue("contactEmail", values?.contactEmail);
//       formik.setFieldValue("userAppversion", values?.userAppversion);
//       formik.setFieldValue("driverAppversion", values?.driverAppversion);            
//       setSiteLogo(values?.siteLogo);
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [values]);

//   // upload site logo

//   const [uploadSiteLogoErros, setUploadSiteLogoErros] = useState([]);
//   const [uploadErros, setUploadErros] = useState([]);
//   const [saveLogoImage, setSaveLogoImage] = useState("");

//   const uploadSiteLogo = (acceptedFiles) => {
//     dispatch(showLoader("Loading please wait..."));
//    // console.log('acceptedFiles-->',acceptedFiles);
//     const onSuccess = (res) => {
//       dispatch(hideLoader());
//       if (res?.data?.status === true) {
//         dispatch(
//           showSnackbar({
//             message: res?.data?.message || "Site logo updated successfully",
//             autoHideDuration: 3000,
//             anchorOrigin: {
//               vertical: "top",
//               horizontal: "right",
//             },
//             variant: "success",
//           })
//         );
//           //Set Site Logo
//               dispatch(
//                 setNewSiteLogo(res?.data?.data?.siteLogo)
//               );
        
//               localStorage.setItem(
//                 "siteLogo",
//                 res?.data?.data?.siteLogo
//               );
        
//         setUploadSiteLogoErros([]);
//         // console.log('res?.data-->',res?.data);
//         setSaveLogoImage(res?.data?.data?.siteLogo);
//       }
//     };
//     const onFailure = (err) => {
//       dispatch(hideLoader());
//       showSnackbar({
//         message: err?.data?.msg || "Error while update the site logo",
//         autoHideDuration: 3000,
//         anchorOrigin: {
//           vertical: "top",
//           horizontal: "right",
//         },
//         variant: "error",
//       });
//     };
//     const formData = new FormData();
//     acceptedFiles?.map((file) => formData.append("image", file));
//     settingsApi.sitelogoupload(formData).then(onSuccess, onFailure);
//   };

//   return (
//     <>
//       <br></br>
//       <br></br>
//         {!demoaccount_id &&
//       <Grid container className={classes.cardContainer}>
//         <Grid item xs={12} md={12} lg={12} xl={12}>
//           <div style={{ padding: "15px" }}>
//             <Typography variant="h5">Site Logo</Typography>
//           </div>
//           <div
//             className={classes.fieldContainer}
//             style={{
//               border: "1px solid #dedede",
//               margin: "10px",
//               borderRadius: "8px",
//               padding: "30px",
//             }}
//           >
//             <DropZone upload={uploadSiteLogo} setUploadErros={setUploadErros} />
//           </div>
//           <div style={{ padding: "15px" }}>
//             {!_.isEmpty(uploadErros) && (
//               <Grid item xs={12} style={{ paddingBlock: 12 }}>
//                 {uploadErros.map(({ file, errors }) => (
//                   <div key={file.path}>
//                     {errors?.map((e) => (
//                       <Typography
//                         style={{ color: "red" }}
//                         variant="caption"
//                         key={e.code}
//                       >
//                         {e.message}
//                       </Typography>
//                     ))}
//                   </div>
//                 ))}
//               </Grid>
//             )}
//             <Typography variant="h5">Preview</Typography>
//             {saveLogoImage ? (
//               <img
//                 src={saveLogoImage}
//                 alt="site logo"
//                 className={classes.siteLogo}
//               />
//             ) : siteLogo !== "" ? (
//               <img
//                 src={siteLogo}
//                 alt="site logo"
//                 className={classes.siteLogo}
//               />
//             ) : (
//               <img
//                 src="/assets/images/logos/no-image.png"
//                 alt="site logo"
//                 className={classes.siteLogo}
//               />
//             )}
//           </div>
//         </Grid> 
//       </Grid> }
//       <br></br>
//       <br></br>
//       <Grid container className={classes.cardContainer}>
//         <Grid
//           item
//           xs={12}
//           md={12}
//           lg={12}
//           xl={12}
//           className={classes.container}
//         >
//           <div style={{ padding: "15px" }}>
//             <Typography variant="h5">General Settings</Typography>
//           </div>
//         </Grid>

//         <Grid item xs={12} md={6} lg={6} xl={6} className={classes.container}>
//           {/* Site Name */}
//           <div className={classes.fieldWrapper}>
//             <Grid item xs={12} md={6} lg={12} xl={12}>
//               <TextField
//                 name="siteName"
//                 id="siteName"
//                 value={formik?.values?.siteName}
//                 onChange={formik?.handleChange}
//                 type={"text"}
//                 fullWidth
//                 variant="outlined"
//                 size="small"
//                 label="Site Name*"
//                 error={formik?.errors?.siteName && formik?.touched?.siteName}
//                 helperText={
//                   formik?.errors?.siteName &&
//                   formik?.touched?.siteName &&
//                   formik?.errors?.siteName
//                 }
//                 disabled={demoaccount_id ? true : false}
//               />
//             </Grid>
//           </div>

//           {/* Copyrights Content */}
//           <Grid
//             item
//             xs={12}
//             md={6}
//             lg={12}
//             xl={12}
//             className={classes.fieldWrapper}
//           >
//             <TextField
//               name="copyRightContent"
//               id="copyRightContent"
//               value={formik?.values?.copyRightContent}
//               onChange={formik?.handleChange}
//               type={"text"}
//               fullWidth
//               variant="outlined"
//               size="small"
//               label="Copyright Content"
//               error={
//                 formik?.errors?.copyRightContent &&
//                 formik?.touched?.copyRightContent
//               }
//               helperText={
//                 formik?.errors?.copyRightContent &&
//                 formik?.touched?.copyRightContent &&
//                 formik?.errors?.copyRightContent
//               }
//               disabled={demoaccount_id ? true : false}
//             />
//           </Grid>

//           <Grid
//             item
//             xs={12}
//             md={6}
//             lg={12}
//             xl={12}
//             className={classes.fieldWrapper}
//           >
//             <TextField
//               name="playStoreLink"
//               id="playStoreLink"
//               value={formik?.values?.playStoreLink}
//               onChange={formik?.handleChange}
//               type="text"
//               fullWidth
//               variant="outlined"
//               size="small"
//               label="Playstore Link"
//               error={
//                 formik?.errors?.playStoreLink && formik?.touched?.playStoreLink
//               }
//               helperText={
//                 formik?.errors?.playStoreLink &&
//                 formik?.touched?.playStoreLink &&
//                 formik?.errors?.playStoreLink
//               }
//               disabled={demoaccount_id ? true : false}
//             />
//           </Grid>

//           {/* Appstore Link */}
//           <Grid
//             item
//             xs={12}
//             md={6}
//             lg={12}
//             xl={12}
//             className={classes.fieldWrapper}
//           >
//             <TextField
//               name="appStoreLink"
//               id="appStoreLink"
//               value={formik?.values?.appStoreLink}
//               onChange={formik?.handleChange}
//               type="text"
//               fullWidth
//               variant="outlined"
//               size="small"
//               label="Appstore Link"
//               error={
//                 formik?.errors?.appStoreLink && formik?.touched?.appStoreLink
//               }
//               helperText={
//                 formik?.errors?.appStoreLink &&
//                 formik?.touched?.appStoreLink &&
//                 formik?.errors?.appStoreLink
//               }
//               disabled={demoaccount_id ? true : false}
//             />
//           </Grid>

//           {/* SOS Number */}
//           <Grid
//             item
//             xs={12}
//             md={6}
//             lg={12}
//             xl={12}
//             className={classes.fieldWrapper}
//           >
//             <TextField
//               name="sosNumber"
//               id="sosNumber"
//               value={formik?.values?.sosNumber}
//               onChange={formik?.handleChange}
//               type="text"
//               fullWidth
//               variant="outlined"
//               size="small"
//               label="SOS Number"
//               error={formik?.errors?.sosNumber && formik?.touched?.sosNumber}
//               helperText={
//                 formik?.errors?.sosNumber &&
//                 formik?.touched?.sosNumber &&
//                 formik?.errors?.sosNumber
//               }
//               disabled={demoaccount_id ? true : false}
//             />
//           </Grid>

//         </Grid>

//         <Grid item xs={12} md={6} lg={6} xl={6} className={classes.container}>

//          {/* Driver app version */}
//           <Grid
//             item
//             xs={12}
//             md={12}
//             lg={12}
//             xl={12}
//             className={classes.fieldWrapper}
//           >
//             <TextField
//               name="driverAppversion"
//               id="driverAppversion"
//               value={formik?.values?.driverAppversion}
//               onChange={formik?.handleChange}
//               type="text"
//               fullWidth
//               variant="outlined"
//               size="small"
//               label="Driver App Version"
//               error={
//                 formik?.errors?.driverAppversion && formik?.touched?.driverAppversion
//               }
//               helperText={
//                 formik?.errors?.driverAppversion &&
//                 formik?.touched?.driverAppversion &&
//                 formik?.errors?.driverAppversion
//               }
//               disabled={demoaccount_id ? true : false}
//             />
//           </Grid>

//          {/* User app version */}
//           <Grid
//             item
//             xs={12}
//             md={12}
//             lg={12}
//             xl={12}
//             className={classes.fieldWrapper}
//           >
//             <TextField
//               name="userAppversion"
//               id="userAppversion"
//               value={formik?.values?.userAppversion}
//               onChange={formik?.handleChange}
//               type="text"
//               fullWidth
//               variant="outlined"
//               size="small"
//               label="User App Version"
//               error={
//                 formik?.errors?.userAppversion && formik?.touched?.userAppversion
//               }
//               helperText={
//                 formik?.errors?.userAppversion &&
//                 formik?.touched?.userAppversion &&
//                 formik?.errors?.userAppversion
//               }
//               disabled={demoaccount_id ? true : false}
//             />
//           </Grid>

//          {/* Contact Number */}
//           <Grid
//             item
//             xs={12}
//             md={12}
//             lg={12}
//             xl={12}
//             className={classes.fieldWrapper}
//           >
//             <TextField
//               name="contactNumber"
//               id="contactNumber"
//               value={formik?.values?.contactNumber}
//               onChange={formik?.handleChange}
//               type="text"
//               fullWidth
//               variant="outlined"
//               size="small"
//               label="Contact Number"
//               error={
//                 formik?.errors?.contactNumber && formik?.touched?.contactNumber
//               }
//               helperText={
//                 formik?.errors?.contactNumber &&
//                 formik?.touched?.contactNumber &&
//                 formik?.errors?.contactNumber
//               }
//               disabled={demoaccount_id ? true : false}
//             />
//           </Grid>

//           {/* Contact Email */}
//           <Grid
//             item
//             xs={12}
//             md={6}
//             lg={12}
//             xl={12}
//             className={classes.fieldWrapper}
//           >
//             <TextField
//               name="contactEmail"
//               id="contactEmail"
//               value={formik?.values?.contactEmail}
//               onChange={formik?.handleChange}
//               type="email"
//               fullWidth
//               variant="outlined"
//               size="small"
//               label="Contact Email"
//               error={
//                 formik?.errors?.contactEmail && formik?.touched?.contactEmail
//               }
//               helperText={
//                 formik?.errors?.contactEmail &&
//                 formik?.touched?.contactEmail &&
//                 formik?.errors?.contactEmail
//               }
//               disabled={demoaccount_id ? true : false}
//             />
//           </Grid>

// {/* IOS Driver Map Key */}
// {/* <Grid
// item
// xs={12}
// md={6}
// lg={12}
// xl={12}
// className={classes.fieldWrapper}
// >
// <TextField
//   name="iosDriverMapKey"
//   id="iosDriverMapKey"
//   value={formik?.values?.iosDriverMapKey}
//   onChange={formik?.handleChange}
//   type={showIosDriverMapKey ? "text" : "password"}
//   fullWidth
//   variant="outlined"
//   size="small"
//   label="IOS Driver Map Key"
//   error={
//     formik?.errors?.iosDriverMapKey &&
//     formik?.touched?.iosDriverMapKey
//   }
//   helperText={
//     formik?.errors?.iosDriverMapKey &&
//     formik?.touched?.iosDriverMapKey &&
//     formik?.errors?.iosDriverMapKey
//   }
//   InputProps={{
//     endAdornment: (
//       <InputAdornment position="end" className={classes.password}>
//         {showIosDriverMapKey ? (
//           <VisibilityIcon
//             onClick={() => setShowIosDriverMapKey(false)}
//           />
//         ) : (
//           <VisibilityOffIcon
//             onClick={() => setShowIosDriverMapKey(true)}
//           />
//         )}
//       </InputAdornment>
//     ),
//   }}
// />
// </Grid> */}

//         </Grid>
//         <Grid item xs={12} md={6} lg={12} xl={12} className={classes.btn}>
//           <Button variant="contained" onClick={formik.handleSubmit} disabled={demoaccount_id ? true : false}>
//             Update
//           </Button>
//         </Grid>
//       </Grid>
//       <br></br>
//       <br></br>
//       <br></br>
//     </>
//   );
// };

// export default SiteSettings;





















import React, { useState, useRef, useEffect, useCallback } from 'react';
import {
  Box,
  Grid,
  Typography,
  Paper,
  TextField,
  InputAdornment,
  Button,
  Chip,
  Avatar,
} from '@mui/material';
import {
  BrandingWatermark,
  SaveOutlined as SaveOutlinedIcon,
  SettingsOutlined,
  CloudUploadOutlined,
  Smartphone,
  Apple,
  WarningAmber,
} from '@mui/icons-material';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import { showLoader, hideLoader } from 'Redux/Loader/actions';
import { showSnackbar } from 'Redux/SnackBar/actions';
import { setNewSiteLogo } from 'Redux/SiteSettings/actions';
import _ from 'lodash';
import settingsApi from 'Services/Settings';

const cardSx = {
  p: 3,
  borderRadius: 3,
  boxShadow: '0px 2px 10px rgba(0,0,0,0.04)',
  backgroundColor: '#fff',
};

const fieldSx = {
  '&.MuiOutlinedInput-root': {
    backgroundColor: '#F9FAFB',
    borderRadius: 2,
    '& fieldset': { border: 'none' },
  },
};

const labelSx = {
  fontWeight: 600,
  fontSize: 13,
  color: '#374151',
  mb: 0.5,
};

const SiteSettings = () => {
  const dispatch = useDispatch();
  const fileInputRef = useRef(null);

  const demoaccount_id = useSelector((state) => state?.AuthReducer?.demoaccount_id || '');
  const userid = useSelector((state) => state?.AuthReducer?.userId || '');

  const [values, setValues] = useState(null);
  const [logoFile, setLogoFile] = useState(null);
  const [logoPreview, setLogoPreview] = useState(null);

  // Save or Edit Settings
  const handleSettings = (formValues) => {
    dispatch(showLoader('Loading please wait...'));
    const data = {
      siteName: formValues?.siteName,
      copyRightContent: formValues?.copyRightContent,
      playStoreLink: formValues?.playStoreLink,
      appStoreLink: formValues?.appStoreLink,
      sosNumber: formValues?.sosNumber,
      contactNumber: formValues?.contactNumber,
      contactEmail: formValues?.contactEmail,
      driverAppversion: formValues?.driverAppversion,
      userAppversion: formValues?.userAppversion,
      demoaccount_id: demoaccount_id,
      userid: userid,
    };

    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        dispatch(showSnackbar({
          message: res?.data?.message || 'Updated site settings successfully',
          autoHideDuration: 3000, anchorOrigin: { vertical: 'top', horizontal: 'right' }, variant: 'success',
        }));
        getMasterValues(); // refresh data
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(showSnackbar({
        message: err?.response?.data?.message || 'Error while updating site settings',
        autoHideDuration: 3000, anchorOrigin: { vertical: 'top', horizontal: 'right' }, variant: 'error',
      }));
    };
    settingsApi.updateMasterValues({...data }).then(onSuccess, onFailure);
  };

  const formik = useFormik({
    initialValues: {
      siteName: '',
      copyRightContent: '',
      playStoreLink: '',
      appStoreLink: '',
      sosNumber: '',
      contactNumber: '',
      contactEmail: '',
      driverAppversion: '',
      userAppversion: '',
    },
    enableReinitialize: true,
    validationSchema: yup.object({
      siteName: yup.string().required('Site Name is required').nullable(),
      driverAppversion: yup.string().required('Driver app version is required').matches(/^\d+(\.\d+)?$/, 'Only numeric versions like 3.0 or 3.6 are allowed').nullable(),
      userAppversion: yup.string().required('User app version is required').matches(/^\d+(\.\d+)?$/, 'Only numeric versions like 3.0 or 3.6 are allowed').nullable(),
      contactNumber: yup.string().required('Contact Number is required').matches(/^[0-9]+$/, 'Only Numbers are allowed').max(10, `Max 10 digits are allowed`).min(10, `Must be exactly 10 numbers`).nullable(),
      contactEmail: yup.string().email('Enter a valid Email Address').nullable(),
      sosNumber: yup.string().matches(/^[0-9]+$/, 'Only Numbers are allowed'),
    }),
    onSubmit: handleSettings,
  });

  // Get Master Values
  const getMasterValues = useCallback(() => {
    dispatch(showLoader('Loading please wait...'));
    const params = {};
    if (userid) params.userid = userid;

    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        setValues(res?.data?.data);
      } else setValues(null);
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(showSnackbar({
        message: err?.response?.data?.message || 'Failed to fetch data',
        autoHideDuration: 3000, anchorOrigin: { vertical: 'top', horizontal: 'right' }, variant: 'error',
      }));
    };
    settingsApi.getMasterValues(params).then(onSuccess, onFailure);
  }, [userid, dispatch]);

  useEffect(() => { getMasterValues(); }, [getMasterValues]);

  // Set fetched values for master
  useEffect(() => {
    if (!_.isEmpty(values)) {
      formik.setValues({
        siteName: values?.siteName || '',
        copyRightContent: values?.copyRightContent || '',
        playStoreLink: values?.playStoreLink || '',
        appStoreLink: values?.appStoreLink || '',
        sosNumber: values?.sosNumber || '',
        contactNumber: values?.contactNumber || '',
        contactEmail: values?.contactEmail || '',
        userAppversion: values?.userAppversion || '',
        driverAppversion: values?.driverAppversion || '',
      });
      setLogoPreview(values?.siteLogo || null);
    }
  }, [values]); // eslint-disable-line

  // Logo Upload
  const handleLogoFile = (file) => {
    if (!file) return;
    const allowedTypes = ['image/png', 'image/jpeg', 'image/svg+xml'];
    if (!allowedTypes.includes(file.type)) {
      dispatch(showSnackbar({ message: 'Only PNG, JPG, and SVG files are allowed.', variant: 'error' })); return;
    }
    if (file.size > 2 * 1024 * 1024) {
      dispatch(showSnackbar({ message: 'File size must be under 2MB.', variant: 'error' })); return;
    }
    setLogoFile(file);
    const reader = new FileReader();
    reader.onloadend = () => setLogoPreview(reader.result);
    reader.readAsDataURL(file);

    // Upload to API
    dispatch(showLoader('Uploading logo...'));
    const formData = new FormData();
    formData.append('image', file);
    settingsApi.sitelogoupload(formData).then((res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        dispatch(showSnackbar({ message: 'Site logo updated successfully', variant: 'success' }));
        dispatch(setNewSiteLogo(res?.data?.data?.siteLogo));
        localStorage.setItem('siteLogo', res?.data?.data?.siteLogo);
        setLogoPreview(res?.data?.data?.siteLogo);
      }
    }).catch((err) => {
      dispatch(hideLoader());
      dispatch(showSnackbar({ message: 'Error while updating logo', variant: 'error' }));
    });
  };

  const handleLogoDrop = (e) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    handleLogoFile(file);
  };

  const isDisabled =!!demoaccount_id;

  return (
    <Box sx={{ minHeight: '100vh', backgroundColor: '#F4F6F9', p: { xs: 2, md: 3 } }}>
      {/* Header */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography variant="h5" sx={{ fontWeight: 700, color: '#111827' }}>Site Settings</Typography>
        <Typography variant="body2" sx={{ color: '#6B7280' }}>
          Admin&nbsp;/&nbsp;<Box component="span" sx={{ color: '#111827', fontWeight: 600 }}>Site Settings</Box>
        </Typography>
      </Box>

      <Grid container spacing={3}>
        {/* LEFT: Branding Card */}
        <Grid item xs={12} md={4}>
          <Paper sx={cardSx}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2.5 }}>
              <BrandingWatermark sx={{ fontSize: 22, color: '#6366F1' }} />
              <Typography variant="subtitle1" sx={{ fontWeight: 700, color: '#111827' }}>Branding</Typography>
            </Box>

            {/* Drag & Drop Zone */}
            {!demoaccount_id && (
              <Box
                onDrop={handleLogoDrop}
                onDragOver={(e) => e.preventDefault()}
                onClick={() => fileInputRef.current?.click()}
                sx={{ border: '2px dashed #D1D5DB', borderRadius: 3, p: 4, textAlign: 'center', cursor: 'pointer', backgroundColor: '#fff', '&:hover': { borderColor: '#6366F1' }, mb: 2.5 }}
              >
                <Avatar sx={{ width: 52, height: 52, backgroundColor: '#EEF2FF', mx: 'auto', mb: 1.5 }}><CloudUploadOutlined sx={{ fontSize: 24, color: '#6366F1' }} /></Avatar>
                <Typography variant="body2" sx={{ fontWeight: 600, color: '#374151' }}>Drag & Drop your logo here</Typography>
                <Typography variant="caption" sx={{ color: '#9CA3AF' }}>PNG, JPG, SVG — Max 2MB</Typography>
                <input ref={fileInputRef} type="file" accept=".png,.jpg,.jpeg,.svg" hidden onChange={(e) => handleLogoFile(e.target.files[0])} />
              </Box>
            )}

            {/* Live Preview */}
            <Box>
              <Typography variant="caption" sx={{ fontWeight: 600, color: '#6B7280', mb: 1, display: 'block' }}>Live Preview</Typography>
              <Box sx={{ border: '1px solid #E5E7EB', borderRadius: 3, height: 140, display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#FA' }}>
                {logoPreview? <Box component="img" src={logoPreview} alt="Logo Preview" sx={{ maxHeight: 120, maxWidth: '90%', objectFit: 'contain' }} /> : <Typography variant="body2" sx={{ color: '#9CA3AF' }}>No logo uploaded</Typography>}
              </Box>
            </Box>
          </Paper>
        </Grid>

        {/* RIGHT: General Configurations */}
        <Grid item xs={12} md={8}>
          <Paper sx={cardSx} component="form" onSubmit={formik.handleSubmit}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2.5 }}>
              <SettingsOutlined sx={{ fontSize: 22, color: '#6366F1' }} />
              <Typography variant="subtitle1" sx={{ fontWeight: 700, color: '#111827' }}>General Configurations</Typography>
            </Box>

            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <Typography sx={labelSx}>Site Name *</Typography>
                <TextField fullWidth size="small" name="siteName" value={formik.values.siteName} onChange={formik.handleChange} onBlur={formik.handleBlur} error={formik.touched.siteName && Boolean(formik.errors.siteName)} helperText={formik.touched.siteName && formik.errors.siteName} sx={fieldSx} disabled={isDisabled} />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography sx={labelSx}>Copyright Content</Typography>
                <TextField fullWidth size="small" name="copyRightContent" value={formik.values.copyRightContent} onChange={formik.handleChange} sx={fieldSx} disabled={isDisabled} />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography sx={labelSx}>SOS Number</Typography>
                <TextField fullWidth size="small" name="sosNumber" value={formik.values.sosNumber} onChange={formik.handleChange} sx={fieldSx} disabled={isDisabled} InputProps={{ startAdornment: <InputAdornment position="start"><WarningAmber sx={{ fontSize: 18, color: '#EF4444' }} /></InputAdornment> }} error={formik.touched.sosNumber && Boolean(formik.errors.sosNumber)} helperText={formik.touched.sosNumber && formik.errors.sosNumber} />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography sx={labelSx}>Contact Number</Typography>
                <TextField fullWidth size="small" name="contactNumber" value={formik.values.contactNumber} onChange={formik.handleChange} sx={fieldSx} disabled={isDisabled} error={formik.touched.contactNumber && Boolean(formik.errors.contactNumber)} helperText={formik.touched.contactNumber && formik.errors.contactNumber} />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography sx={labelSx}>Contact Email</Typography>
                <TextField fullWidth size="small" name="contactEmail" type="email" value={formik.values.contactEmail} onChange={formik.handleChange} sx={fieldSx} disabled={isDisabled} error={formik.touched.contactEmail && Boolean(formik.errors.contactEmail)} helperText={formik.touched.contactEmail && formik.errors.contactEmail} />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography sx={labelSx}>Playstore Link</Typography>
                <TextField fullWidth size="small" name="playStoreLink" value={formik.values.playStoreLink} onChange={formik.handleChange} sx={fieldSx} disabled={isDisabled} InputProps={{ startAdornment: <InputAdornment position="start"><Smartphone sx={{ fontSize: 18, color: '#10B981' }} /></InputAdornment> }} />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography sx={labelSx}>Appstore Link</Typography>
                <TextField fullWidth size="small" name="appStoreLink" value={formik.values.appStoreLink} onChange={formik.handleChange} sx={fieldSx} disabled={isDisabled} InputProps={{ startAdornment: <InputAdornment position="start"><Apple sx={{ fontSize: 18, color: '#374151' }} /></InputAdornment> }} />
              </Grid>
            </Grid>

            {/* App Version Cards */}
            <Grid container spacing={2} sx={{ mt: 1 }}>
              <Grid item xs={12} sm={6}>
                <Box sx={{ backgroundColor: '#F9FAFB', borderRadius: 2, p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <Box>
                    <Typography variant="caption" sx={{ color: '#6B7280', fontWeight: 600 }}>Driver App Version</Typography>
                    <TextField fullWidth size="small" name="driverAppversion" value={formik.values.driverAppversion} onChange={formik.handleChange} sx={{...fieldSx, mt: 0.5 }} disabled={isDisabled} error={formik.touched.driverAppversion && Boolean(formik.errors.driverAppversion)} helperText={formik.touched.driverAppversion && formik.errors.driverAppversion} />
                  </Box>
                  <Chip label="STABLE" size="small" sx={{ backgroundColor: '#D1FAE5', color: '#065F46', fontWeight: 700, fontSize: 11 }} />
                </Box>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Box sx={{ backgroundColor: '#F9FAFB', borderRadius: 2, p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <Box>
                    <Typography variant="caption" sx={{ color: '#6B7280', fontWeight: 600 }}>User App Version</Typography>
                    <TextField fullWidth size="small" name="userAppversion" value={formik.values.userAppversion} onChange={formik.handleChange} sx={{...fieldSx, mt: 0.5 }} disabled={isDisabled} error={formik.touched.userAppversion && Boolean(formik.errors.userAppversion)} helperText={formik.touched.userAppversion && formik.errors.userAppversion} />
                  </Box>
                  <Chip label="STABLE" size="small" sx={{ backgroundColor: '#D1FAE5', color: '#065F46', fontWeight: 700, fontSize: 11 }} />
                </Box>
              </Grid>
            </Grid>

            {/* Save Button */}
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              <Button type="submit" variant="contained" startIcon={<SaveOutlinedIcon />} disabled={isDisabled || formik.isSubmitting} sx={{ backgroundColor: '#111827', color: '#fff', textTransform: 'none', fontWeight: 600, px: 3, py: 1, borderRadius: 2, '&:hover': { backgroundColor: '#1F2937' } }}>
                Save Configuration
              </Button>
            </Box>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default SiteSettings;
